// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"cdccef8a","95":"eadb5c91","622":"3f61ed8f","769":"39b76d00","901":"65358b34"}[chunkId] + ".chunk.css";
};